export enum MetadataKeys {
  // Add user metadata
  LOGIN_STATUS = "login-status",
  AUTHENTICATION_TYPE = "authentication-type",
  USER_OR_IP_RANGE_SALESFORCE_ID = "user-or-ip-range-salesforce-id",
  USER_ORGANIZATION_SALESFORCE_ID = "user-organization-salesforce-id",
  USER_PERMISSIONS = "user-permissions",
  // Add page metadata
  CONTENT_TITLE = "content-title",
  CMS_CONTENT_ID = "cms-content-id",
  SITESECTION_CHANNEL = "sitesection-channel",
  CMS_TAGS = "cms-tags",
  PAYWALLED_CONTENT_STATUS = "paywalled-content-status",
  PAGE_TYPE = "page-type",
  SITESECTION = "sitesection",
  VIGNETTE_PRIMARY_PROFILE_TYPE = "vignette-primary-profile-type",
}

export type MetadataField = string | undefined;

export interface Metadata {
  // User metadata
  [MetadataKeys.LOGIN_STATUS]: MetadataField;
  [MetadataKeys.AUTHENTICATION_TYPE]: MetadataField;
  [MetadataKeys.USER_OR_IP_RANGE_SALESFORCE_ID]: MetadataField;
  [MetadataKeys.USER_ORGANIZATION_SALESFORCE_ID]: MetadataField;
  [MetadataKeys.USER_PERMISSIONS]: MetadataField;

  // Page metadata
  [MetadataKeys.CONTENT_TITLE]: MetadataField;
  [MetadataKeys.CMS_CONTENT_ID]: MetadataField | undefined;
  [MetadataKeys.SITESECTION_CHANNEL]: MetadataField;
  [MetadataKeys.CMS_TAGS]: MetadataField | undefined;
  [MetadataKeys.PAYWALLED_CONTENT_STATUS]: MetadataField;
  [MetadataKeys.PAGE_TYPE]: MetadataField;
  [MetadataKeys.SITESECTION]: MetadataField;
  [MetadataKeys.VIGNETTE_PRIMARY_PROFILE_TYPE]: MetadataField | undefined;
}
